import { StrictMode } from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

// Global styles and third-party styles
import "antd/dist/antd.css";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./styles.scss";

import App from "./app/app";
import { environment } from "./environments/environment";

// Local-only global error overlay for debugging without DevTools.
if (typeof window !== "undefined" && environment.isLocal) {
  const ensureErrorOverlay = () => {
    let el = document.getElementById("global-error-overlay");
    if (!el) {
      el = document.createElement("div");
      el.id = "global-error-overlay";
      el.style.position = "fixed";
      el.style.left = "0";
      el.style.right = "0";
      el.style.bottom = "0";
      el.style.maxHeight = "40%";
      el.style.overflow = "auto";
      el.style.background = "#fff1f0";
      el.style.borderTop = "1px solid #ffa39e";
      el.style.padding = "8px 12px";
      el.style.fontFamily = "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
      el.style.fontSize = "12px";
      el.style.zIndex = "9999";
      document.body.appendChild(el);
    }
    return el;
  };

  window.onerror = function (message, source, lineno, colno, error) {
    const el = ensureErrorOverlay();
    const msg = [
      "JS Error: " + String(message ?? ""),
      source ? "Source: " + source + ":" + lineno + ":" + colno : "",
      error && (error as Error).stack ? "Stack: " + (error as Error).stack : "",
    ]
      .filter(Boolean)
      .join("\n");
    el.textContent = msg;
  };

  window.onunhandledrejection = function (event: PromiseRejectionEvent) {
    const el = ensureErrorOverlay();
    const reason = event.reason instanceof Error ? event.reason.stack || event.reason.message : String(event.reason);
    el.textContent = "Unhandled Promise Rejection:\n" + reason;
  };
}

// Defer cube-helper config to avoid circular dependency with @loops-webv2/ui
// (Cannot access __WEBPACK_DEFAULT_EXPORT__ before initialization)
import("./app/cube-helper-config").then(({ initCubeHelperConfig }) => initCubeHelperConfig());

function renderApp() {
  ReactDOM.render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
    document.getElementById("root")
  );
}

function shouldRenderApp() {
  return !window.__TEAMS_SETTINGS_FRAME;
}

const teamsReady = window.__TEAMS_READY;
if (teamsReady) {
  teamsReady
    .then(() => {
      // Config iframe is handled by index.html so Teams can save tab settings
      // before the React bundle loads. A second Teams SDK instance from React
      // is what lets the full dashboard appear in the Save dialog.
      if (shouldRenderApp()) {
        renderApp();
      }
    })
    .catch(() => {
      if (shouldRenderApp()) {
        renderApp();
      }
    });
} else {
  renderApp();
}
